export const useRedirectToCamera = () => {
  //カメラにリダイレクト
  const onClickRedirect = (redirect_url: string) => {
    if (typeof redirect_url !== 'undefined') {
      //別タブで表示する
      window.open(redirect_url, '_blank');
    }
  };

  return { onClickRedirect };
};

export const useRedirectToCameraByDate = () => {
  //カメラにリダイレクト
  const onClickRedirect = (redirect_url: string, dateStr: string) => {
    if (typeof redirect_url !== 'undefined' && typeof dateStr !== 'undefined') {
      const base64Date = btoa(dateStr);
      //別タブで表示する
      window.open(redirect_url + base64Date, '_blank');
    }
  };

  return { onClickRedirect };
};
